import http from '../../config/http-common';

//Usado somente se for realmente necessário algo fora do padrão GeneralCRUD.service.js
const path = "checklist"

class service {


    selectList(params) {
        return http.list(path + "/selectList", params);
    }

    getResume(type, param, allStatus = false) {

        return http.getResume(path,type,param,allStatus);

    }

    onBusinessEvidenceFileRequiredFieldsToString(obj) {
        let result = "";

        const allShowTrue = obj.categoryShow && obj.serviceShow && obj.statusShow && obj.complementShow;
        const allRequiredTrue = obj.categoryRequired && obj.serviceRequired && obj.statusRequired && obj.complementRequired;

        const allShowFalse = !obj.categoryShow && !obj.serviceShow && !obj.statusShow && !obj.complementShow;

        if (allShowTrue && allRequiredTrue) return "Y";
        if (allShowFalse) return "N";

        if (obj.categoryShow && obj.categoryRequired) result += "category*|";
        else if (obj.categoryShow) result += "category|";

        if (obj.serviceShow && obj.serviceRequired) result += "service*|";
        else if (obj.serviceShow) result += "service|";

        if (obj.statusShow && obj.statusRequired) result += "status*|";
        else if (obj.statusShow) result += "status|";

        if (obj.complementShow && obj.complementRequired) result += "complement*|";
        else if (obj.complementShow) result += "complement|";

        // Remove o último separador "|"
        if (result.endsWith("|")) result = result.slice(0, -1);

        return result;
    }

    onBusinessEvidenceFileLabelOrderFieldsToString(obj) {

        const fields = []

        if (obj.categoryShow) {
            fields.push({
                key: 'category',
                label: obj.categoryLabel || 'Categoria',
                order: obj.categoryOrder || 1
            });
        }

        if (obj.serviceShow) {
            fields.push({
                key: 'service',
                label: obj.serviceLabel || 'Serviço',
                order: obj.serviceOrder || 2
            });
        }

        if (obj.statusShow) {
            fields.push({
                key: 'status',
                label: obj.statusLabel || 'Status',
                order: obj.statusOrder || 3
            });
        }

        if (obj.complementShow) {
            fields.push({
                key: 'complement',
                label: obj.complementLabel || 'Detalhe do Ambiente',
                order: obj.complementOrder || 4
            });
        }



        // Ordena pela ordem escolhida
        fields.sort((a, b) => a.order - b.order);

        let result = '';

        fields.forEach(field => {

            result += `${field.key}:{${field.label}}|`;

        });

        // Remove último |
        if (result.endsWith('|')) {
            result = result.slice(0, -1);
        }

        // Verifica padrão original
        const defaultResult =
            'category:{Categoria}|service:{Serviço}|status:{Status}|complement:{Detalhe do Ambiente}';

        if (result === defaultResult) {
            return '';
        }

        return result;
    }

    //------------------------------------------------
    //REPLICAR EM TypeChecklistModelForm e ChecklistEnvironmentEvidenceFile
    onBusinessEvidenceFileRequiredFieldsFromString(str, labelOrder = '') {

        console.log(labelOrder)

        const result = {
            categoryShow: false,
            categoryRequired: false,
            categoryLabel: 'Categoria',
            categoryOrder: 1,

            serviceShow: false,
            serviceRequired: false,
            serviceLabel: 'Serviço',
            serviceOrder: 2,

            statusShow: false,
            statusRequired: false,
            statusLabel: 'Status',
            statusOrder: 3,

            complementShow: false,
            complementRequired: false,
            complementLabel: 'Detalhe do Ambiente',
            complementOrder: 4,
        };

        // =========================
        // LABELS E ORDEM
        // =========================

        if (labelOrder) {

            const orderParts = labelOrder.split('|').filter(Boolean);

            orderParts.forEach((item, index) => {

                const match = item.match(/^(.+):\{(.+)\}$/);

                if (!match) return;

                const field = match[1];
                const label = match[2];

                if (field === 'category') {
                    result.categoryLabel = label;
                    result.categoryOrder = index + 1;
                }

                if (field === 'service') {
                    result.serviceLabel = label;
                    result.serviceOrder = index + 1;
                }

                if (field === 'status') {
                    result.statusLabel = label;
                    result.statusOrder = index + 1;
                }

                if (field === 'complement') {
                    result.complementLabel = label;
                    result.complementOrder = index + 1;
                }

            });

        }

        // =========================
        // VISIBILIDADE / OBRIGATORIEDADE
        // =========================

        if (str === "N") return result;

        if (str === "Y") {

            result.categoryShow = true;
            result.categoryRequired = true;

            result.serviceShow = true;
            result.serviceRequired = true;

            result.statusShow = true;
            result.statusRequired = true;

            result.complementShow = true;
            result.complementRequired = true;

            return result;
        }

        const parts = str.split("|").filter(Boolean);

        parts.forEach(item => {

            const isRequired = item.endsWith("*");
            const base = isRequired ? item.slice(0, -1) : item;

            if (base === "category") {
                result.categoryShow = true;
                result.categoryRequired = isRequired;
            }

            if (base === "service") {
                result.serviceShow = true;
                result.serviceRequired = isRequired;
            }

            if (base === "status") {
                result.statusShow = true;
                result.statusRequired = isRequired;
            }

            if (base === "complement") {
                result.complementShow = true;
                result.complementRequired = isRequired;
            }

        });

        return result;
    }


}

export default new service();

